import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { environment } from "@environments/environment";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  constructor(private http: HttpClient, private toast: ToastrService) {}

  getMyProjects() {
    return this.http.get<any>(`${environment.apiUrl}users/myProjects`);
  }
  getPwMyProjects() {
    return this.http.get<any>(`${environment.apiUrl}users/myProject/web`);
  }

  getAbout() {
    return this.http.get<any>(environment.apiUrl + "about");
  }

  getDefaultProject() {
    return this.http.get<any>(`${environment.apiUrl}projectUserRole/defaultProject`);
  }

  getHistoryLog(requestParams: any) {
    return this.http.post<any>(`${environment.apiUrl}historyLog`, requestParams);
  }

  clone(type, postData) {
    if (type === "ENDPOINT") {
      type = "endPoints/";
      return this.http.post(`${environment.apiUrl + type}clone`, postData);
    }

    if (type === "TESTCASE") type = "testCases";
    if (type === "TESTSUITE") type = "testSuites";
    if (type === "MASTERSUITE") type = "masterSuites";

    return this.http.post<any>(`${environment.apiUrl + type}/${postData.id}/clone`, postData);
  }

  delete(type, postData) {
    if (type === "ENDPOINT") type = "endPoints";
    if (type === "TESTCASE") type = "testCases";
    if (type === "TESTSUITE") type = "testSuites";
    if (type === "MASTERSUITE") type = "masterSuites";

    return this.http.delete<any>(`${environment.apiUrl + type}/${postData.id}`);
  }

  getEnvironmentsMap(type, id) {
    if (type != "ENDPOINT") {
      return this.http.get<any>(`${environment.apiUrl}environmentMaps/projects/${id}`);
    } else {
      return this.http.get<any>(environment.apiUrl + "environments/idNamePair/endPoints/" + id);
    }
  }

  loadScreenShot(noSqlId: string, endpointExecutionNoSqlId): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}result/endPoints/webInstruction/screenShot/${noSqlId}?execution=${endpointExecutionNoSqlId}`);
  }

  readEndPointResultsFromNoSql(noSqlId): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}result/endPoints/${noSqlId}`);
  }

  readEndPointResultsFromNoSqlTestdataOrder(noSqlId, testDataSequence, testCaseRetryAttempt?: any): Observable<any> {
    if(testCaseRetryAttempt === undefined) {
      return this.http.get<any>(`${environment.apiUrl}result/endPoints/${noSqlId}/testDataSequence/${testDataSequence}`);
    } else {
      return this.http.get<any>(`${environment.apiUrl}result/endPoints/${noSqlId}/testDataSequence/${testDataSequence}?retryAttempt=${testCaseRetryAttempt}`);
    }
  }

  getHostName(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + "about");
  }

  actionOnCondtionsResults(endPointNoSQLId: string, index: number): Observable<any> {
    return this.http.get<any>(environment.apiUrl + "result/actionMgmt/endPoint/" + endPointNoSQLId + "/" + index);
  }

  readValidationResultsByNoSqlId(endPointNoSQLId: string, index: number): Observable<any> {
    return this.http.get<any>(environment.apiUrl + "result/validations/endPoint/" + endPointNoSQLId + "/" + index);
  }

  // read test case --> endpoint --> sync data by nosqlId
  readSyncDataByNoSqlId(noSqlId: string, index: number): Observable<any> {
    return this.http.get<any>(environment.apiUrl + "result/testData/endPoint/" + noSqlId + "/" + index);
  }

  // read test case --> endpoint --> Resp Extractor by nosqlId
  readRespExtractorByNoSqlId(noSqlId: string, index: number): Observable<any> {
    return this.http.get(environment.apiUrl + "result/responseExtractors/endPoint/" + noSqlId + "/" + index);
  }

  genericComparator(objOne: any, objTwo: any): boolean {
    if (objTwo === null) {
      return true;
    }
    return objOne && objTwo && objOne.id === objTwo.id;
  }

  base64ToArrayBuffer(data: any) {
    var binaryString = window.atob(data);
    var binLength = binaryString.length;
    var bytes = new Uint8Array(binLength);
    for (var i = 0; i < binLength; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  getUsersByProject(projects): Observable<any> {
    return this.http.post<any>(environment.apiUrl + "performanceRequests/users", projects);
  }

  httpMsg(resp) {
    if (resp.code === 200) {
      this.toast.success(resp.message);
    } else {
      this.toast.error(resp.message);
    }
  }

  exportExtractedGlobalTestData(executedTaskId : any, type : any) {
    return this.http.get(environment.apiUrl + `result/responseExtractors/export/global/${executedTaskId}?executionType=${type}`);
  }

  getExecutedWebInstructionList(endPointNoSqlId, testDataSequence) {
    return this.http.get<any>(`${environment.apiUrl}result/endPoints/webInstructions/${endPointNoSqlId}/testDataSequence/${testDataSequence}`);
  }

  getResponseExtractorById(responseExtractorId : any) {
    return this.http.get(environment.apiUrl + `result/responseExtractors/${responseExtractorId}`);
  }
}
